import { FC, memo } from "react";
import { MatchStatus } from "service";
import styled from "styled-components";
import { SIDE } from "_constants";
import { getTeamColors } from "components/colors";

export const PowerPlayIndicator: FC<{ status: MatchStatus }> = memo(
  ({ status: { nsc, side, ...status } }) => {
    const isPowerPlay = nsc === "1272" || nsc === "1289";

    const { home, away } = getTeamColors(status as any);
    const fillColor = side === SIDE.HOME ? home : away;

    if (!isPowerPlay) return null;

    const PATH_D =
      "M0 20C0 8.9543 8.95431 0 20 0H114V180H20C8.9543 180 0 171.046 0 160V20Z";

    return (
      <PathContainer className="attack-indicator" side={side as SIDE}>
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 114 180"
          preserveAspectRatio="none"
        >
          <defs>
            <linearGradient
              id="gradient"
              gradientUnits="userSpaceOnUse"
              x1="0"
              y1="0"
              x2="114"
              y2="0"
            >
              <stop offset="0%" stopColor={fillColor} stopOpacity={1} />
              <stop offset="100%" stopColor={fillColor} stopOpacity={1} />
            </linearGradient>
          </defs>
          <path
            d={PATH_D}
            fill={`url(#gradient)`}
            opacity={0.5}
            transform={
              String(side) === String(SIDE.AWAY)
                ? "translate(114 0) scale(-1 1)"
                : undefined
            }
          />
        </svg>
      </PathContainer>
    );
  }
);

const PathContainer = styled.div<{ side?: SIDE }>`
  position: absolute;
  top: 0;
  bottom: 0;
  padding-left: ${({ side }) => (side === SIDE.HOME ? "6.2vw" : "0")};
  padding-right: ${({ side }) => (side === SIDE.AWAY ? "7vw" : "0")};
  width: 100%;
  height: 100%;
  pointer-events: none;

  & > svg {
    width: 30.5%;
    height: 100%;
    display: block;
    margin-left: ${({ side }) => (side === SIDE.AWAY ? "auto" : "0")};
    margin-right: ${({ side }) => (side === SIDE.HOME ? "auto" : "0")};
  }
`;
